module.exports = __webpack_public_path__ + "assets/images/businessCard-04.8023cdf4241a2404e47a483d914beb96.svg";